<template>
  <section>
    <div class="row mb-4">
      <button :class="['btn', 'btn-secondary', { 'active': 'phone' == cl }]" @click="setRT('phone')"> <i
          class="fas fa-phone icon"></i> </button>

      <button :class="['btn', 'btn-secondary', { 'active': 'chat' == cl }]" @click="setRT('chat')"> <i
          class="fas fa-comment icon"></i> </button>

      <button :class="['btn', 'btn-secondary', { 'active': 'toogle' == cl }]" @click="setRT('toogle')"> <i
          class="fas fa-reply icon"></i> </button>
    </div>

    <div class="row m-4">
      <div class="col-md-8" :class="[{ 'toogle-el': toogleRealtime }]">
        <TbFilaURA @open-modal-transf="handleOpenModalTransf" />
        <ModalTransferencia ref="modalTransferencia" :valueClient=dadoClient></ModalTransferencia>
        <TbFilaAtendimento @open-modal-transf="handleOpenModalTransf" />
        <TbFilaAndamento @open-modal-transf="handleOpenModalTransf" />
      </div>

      <div class="col-md-4 p-0" :class="!toogleRealtime ? 'container-align' : 'toogle-el'">
        <TbFilaDetail class="m-2" />
        <GraficoRespondids class="m-2" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-8" :class="!toogleRealtime ? 'container-align' : 'toogle-el'">
        <TbUsers ref="tbUsers" />
      </div>

      <div class="col-md-4" :class="[{ 'toogle-el': toogleRealtime }]">
        <GraficoOcupacaoAgent />
      </div>

      <realtime-phone :class="[{ 'toogle-el': !toogleRealtime }]" />
    </div>
  </section>
</template>

<script>
import TbUsers from "./components/TbUsers";
import GraficoRespondids from "./components/GraficoRespondids";
import GraficoOcupacaoAgent from "./components/GraficoOcupacaoAgent";
import TbFilaAtendimento from "./components/TbFilaAtendimento";
import RealtimePhone from './RealtimePhone.vue';
import TbFilaURA from "./components/TbFilaURA";
import TbFilaAndamento from "./components/TbFilaAndamento";
import TbFilaDetail from "./components/TbFilaDetail";
import ModalTransferencia from '../../components/newScreen/mensagem/ModalTransferencia.vue';

export default {
  name: "RealtimeApp",
  components: {
    TbFilaAtendimento,
    TbFilaURA,
    TbFilaAndamento,
    TbFilaDetail,
    GraficoOcupacaoAgent,
    GraficoRespondids,
    TbUsers,
    RealtimePhone,
    ModalTransferencia
  },
  data() {
    return {
      toogleRealtime: true,
      intervalId: '',
      cl: 'toogle',
      dadoClient: '',
      settings: {
        tvMode: "mini",
        tab: "toogle",
        filter: "all",
      }
    }
  },
  created() {
	  console.log('debug')
    const cookies = getCookie("realtimeSettings");
    if (cookies) {
      this.settings = cookies;
    } else {
      setCookie('realtimeSettings', JSON.stringify(this.settings));
    }

    this.setRT(this.settings.tab);
    changeTVMode(this.settings.tvMode);
  },
  methods: {
    handleOpenModalTransf(dado) {
      this.dadoClient = dado;
      this.$refs.modalTransferencia.openModal();
    },
    setRT(style) {
      this.cl = style
      clearInterval(this.intervalId);
      setCookie("realtimeSettings", style, "tab");

      if (style == 'phone') {
        return this.toogleRealtime = true;
      }

      if (style == 'chat') {
        return this.toogleRealtime = false;
      }

      if (style == 'toogle') {
        this.intervalId = setInterval(() => {
          this.toogleRealtime = !this.toogleRealtime
        }, 15000)
      }
    },
  },
}
</script>

<style scoped>
.toogle-el {
  display: none;
}

.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
